import React from 'react';

const DataAccess = () => {
  return (
    <div className="WSNG-data-access-container">


    </div>
  );
};

export default DataAccess;
